import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import SolutionsHero from "./components/SolutionsHero";
import ProductAdvisorCTA from "./components/ProductAdvisorCTA";
import SolutionCards from "./components/SolutionCards";
import SolutionsFinalCTA from "./components/SolutionsFinalCTA";
import { usePageMeta } from "../../hooks/usePageMeta";

export default function SolutionsPage() {
  usePageMeta(
    "Solutions | StackMap Systems - 8 Industry Solutions, Order & Inventory, Workforce, CRM & More",
    "StackMap delivers 8 industry solutions including order and inventory management, workforce management, quality and operational compliance, performance tracking, remote operations, customer acquisition and pipeline, workplace operations, and gym & wellness management."
  );

  return (
    <div className="min-h-screen bg-graphite-900">
      <Navbar />
      <main>
        <SolutionsHero />
        <ProductAdvisorCTA />
        <SolutionCards />
        <SolutionsFinalCTA />
      </main>
      <Footer />
    </div>
  );
}